export default __webpack_public_path__ + "static/media/graphic-design.f41ad80b.png";